var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4114 18.773C36.427 18.773 36.4426 18.7729 36.4582 18.7729C41.6358 18.7729 45.8332 22.978 45.8332 28.1651C45.8332 32.9996 42.1873 36.9809 37.4998 37.5M36.4114 18.773C36.4424 18.4293 36.4582 18.0812 36.4582 17.7294C36.4582 11.3895 31.3281 6.25 24.9998 6.25C19.0066 6.25 14.088 10.8597 13.5841 16.7332M36.4114 18.773C36.1984 21.1408 35.2678 23.3013 33.8391 25.0344M13.5841 16.7332C8.2998 17.2369 4.1665 21.6957 4.1665 27.1215C4.1665 32.1703 7.74517 36.3817 12.4998 37.3486M13.5841 16.7332C13.9129 16.7018 14.2462 16.6858 14.5832 16.6858C16.9286 16.6858 19.0931 17.4624 20.8342 18.7729",
    stroke: "#2A353D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 43.75L24.9998 27.0833M24.9998 43.75C23.541 43.75 20.8155 39.5952 19.7915 38.5417M24.9998 43.75C26.4586 43.75 29.1842 39.5952 30.2082 38.5417",
    stroke: "#2A353D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.cb7ca954f02965a3735d774dcb15fab0.svg";
export { ForwardRef as ReactComponent };